// @ts-expect-error - we are using React 17 types but have 18 installed
import {useMemo, useSyncExternalStore} from 'react'

import {
  DEFAULT_USER_MAX_FREEZE_LIMIT,
  DEFAULT_USER_MAX_MONTHLY_FREEZE_LIMIT,
  getFreezeLimits
} from '../../business/dealFreeze'
import {getConfigurationVersion, subscribeToConfiguration} from './store'

const SERVER_VERSION = -1

export const useFreezeLimits = () => {
  const version: number = useSyncExternalStore(
    subscribeToConfiguration,
    getConfigurationVersion,
    () => SERVER_VERSION
  )

  return useMemo(
    () =>
      version === SERVER_VERSION
        ? {
            atOnce: DEFAULT_USER_MAX_FREEZE_LIMIT,
            monthly: DEFAULT_USER_MAX_MONTHLY_FREEZE_LIMIT
          }
        : getFreezeLimits(),
    [version]
  )
}
